// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"2e40d6e5","768":"067fdfb1","916":"1f42a64e"}[chunkId] + ".chunk.css";
};